import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DashBoardAdministrador from '../layouts/DashBoardAdministrador.js';
import VentaDiaria from '../ventas-diarias/ventasDiarias.js';
import FormularioVentaAdminNuevo from '../formulario/formularioVentaAdminNuevo.js';
import VerVentaAdministrador from '../ventas-diarias/verVentas.js';

function RutasAdministrador() {
  return (
    <Routes>
      <Route path="/" element={<DashBoardAdministrador />}>
      <Route path="/punto-venta" element={<FormularioVentaAdminNuevo />} />
      <Route path="/ventas-diarias" element={<VentaDiaria />} />
      <Route path="/ventas-diarias/:id" element={<VerVentaAdministrador />} />
      </Route>
    </Routes>
  );
}

export default RutasAdministrador;